import React from "react";
import { ReactComponent as GastroSupplierSVG } from "../../../../../../../../images/svg/apps/large/gastrosupplier.svg";
import { ReactComponent as GoCrmSVG } from "../../../../../../../../images/svg/apps/large/goclient.svg";
import { ReactComponent as GoOrderSVG } from "../../../../../../../../images/svg/apps/large/goorder.svg";
import { ReactComponent as GoposSVG } from "../../../../../../../../images/svg/apps/large/gopos.svg";
import { ReactComponent as GoStockSVG } from "../../../../../../../../images/svg/apps/large/gostock.svg";
import { ReactComponent as GoTicketSVG } from "../../../../../../../../images/svg/apps/large/goticket.svg";
import { ApplicationProvider, ApplicationTemplateApi } from "../../../../../../../../services/Api/Organization/types";

interface Props {
	app: ApplicationTemplateApi;
}

const AppIcon = ({ app }: Props) => {
	const render = () => {
		if (app.logo_link) {
			return <img alt={app.provider} className={"application-template-logo"} src={app.logo_link} />;
		}

		switch (app.provider) {
			case ApplicationProvider.GOPOS:
			case ApplicationProvider.CALL_RECORDER:
			case ApplicationProvider.LOCATIONS:
				return <GoposSVG />;
			case ApplicationProvider.GOCRM:
				return <GoCrmSVG />;
			case ApplicationProvider.GASTROSUPPLIER:
				return <GastroSupplierSVG />;
			case ApplicationProvider.GOTICKET:
				return <GoTicketSVG />;
			case ApplicationProvider.GOORDER:
				return <GoOrderSVG />;
			case ApplicationProvider.GOSTOCK:
				return <GoStockSVG />;
			default:
				return <img className={"application-template-logo"}></img>;
		}
	};

	return render();
};

export default AppIcon;
